import * as CookieService from "./cookie";
import * as LocalStorageService from "./local-storage";
import type {
  StorageInterface,
  StorageValue,
  StorageProperties,
} from "./storage-type";

const createStorageWrapper = (
  storageService: StorageInterface,
  isCookieStorage = false,
): StorageInterface => {
  const canPerformOperation = () => {
    const hasCookieConsent = true;
    const canUseStorage =
      typeof window !== "undefined" && typeof document !== "undefined";

    return canUseStorage && (!isCookieStorage || hasCookieConsent);
  };

  return {
    clear: (): void => {
      if (canPerformOperation()) {
        storageService.clear();
      }
    },

    get: (key: string): string | null =>
      canPerformOperation() ? storageService.get(key) : null,

    has: (key: string): boolean =>
      canPerformOperation() ? storageService.has(key) : false,

    keys: (): string[] => (canPerformOperation() ? storageService.keys() : []),

    remove: (key: string): void => {
      if (canPerformOperation()) {
        storageService.remove(key);
      }
    },

    set: (
      key: string,
      value: StorageValue,
      properties?: StorageProperties,
    ): void => {
      if (canPerformOperation()) {
        storageService.set(key, value, properties);
      }
    },

    update: (key: string, value: StorageValue): void => {
      if (canPerformOperation()) {
        storageService.update(key, value);
      }
    },
  };
};

export const CookieStorage = createStorageWrapper(CookieService, true);
export const LocalStorage = createStorageWrapper(LocalStorageService);
